<patron-accordion
  [tabs]="[{ header: ticketTask!.title!, template: content }]"
  [opened]="true"
  [customClass]="
    'sprint-accordion sprint-inner-accordion ' + tcTicketService.getAccordionColorClass(color)
  ">
  <ng-template #content>
    @if (ticketTask!.ticketTasks) {
      <div>
        @for (
          ticketTask of ticketTask!.ticketTasks;
          track ticketTask;
          let ticketTaskIndex = $index
        ) {
          <div
            pDroppable
            (onDrop)="
              dropEmitter.emit({
                event: $event,
                target: 'innerTicketCard',
                ticketTask: ticketTask,
                title: title,
                user: user,
                index: ticketTaskIndex,
                parentIndex: parentIndex,
              })
            ">
            <app-ticket-card-container
              pDraggable
              (onDragStart)="
                dragStartEmitter.emit({
                  event: $event,
                  ticketTask: ticketTask,
                  title: ticketTask,
                  user: user,
                  index: ticketTaskIndex,
                  parentIndex: parentIndex,
                })
              "
              [ticketTask]="ticketTask"
              [user]="user"
              [color]="color"
              [readOnly]="readOnly"
              [isBeta]="isBeta"
              [title]="'Atrasados' + ticketTask!.title!"
              [showDate]="false"
              (click)="openTicketModal($event, ticketTask)"></app-ticket-card-container>
          </div>
        }
      </div>
    }
  </ng-template>
</patron-accordion>
